import { useSearchParams } from "react-router-dom";
import AddLookup from "../../../Components/InputComponents/AddLookup";

function AddProfession() {
  const [searchParams] = useSearchParams();
  const redirectURL = `/ProfessionLookup?${searchParams.toString()}`;

  return (
    <AddLookup
      title="Add Profession"
      alert="Profession Added Successfully"
      addDataAPIEndpoint="/Profession/add"
      redirectURL={redirectURL}
      sections={[
        {
          fields: [
            {
              type: "text",
              label: "Profession",
              name: "PI_Name",
              required: true, // Validation rule added here
               maxLength:70
            },
            {
              type: "select",
              label: "Status",
              name: "PI_Status",
              required: true, // Validation rule added here
              
              options: [
                { label: "Active", value:'1'},
                { label: "Inactive", value: '0'},
              ],
            },
          ],
        },
      ]}
      validationRules={{
        PI_Name: {
          required: true,
          
        },
        PI_Status: {
          required: true,
        },
      }}
    />
  );
}

export default AddProfession;
